import * as formats from "../../../common/formats";

// SF連携
$(() => {
    if (document.getElementById('agent-sf-contract-form') != null) {
		$('.js-data-price').on('change', function(e) {
            updatePrice();
        });
        $('#sf_contract_modal').on('show.bs.modal', function () {
            setupRelation();
        })

        updatePrice();
    }
});

// 金額の更新
function updatePrice()
{
    // 支払小計(税込)
    let payMonth = parseInt(formats.convertNum($('#payMonth').val())) || 0;
    let payAdjust = parseInt(formats.convertNum($('#payAdjust').val())) || 0;
    let payWork = parseInt(formats.convertNum($('#payWork').val())) || 0;
    let payOnetime = parseInt(formats.convertNum($('#payOnetime').val())) || 0;
    let tax = (100 + parseFloat(formats.convertNum($('#salesTax').val()))) / 100;
    let subtotal = (payMonth + payAdjust + payWork + payOnetime);
    let subtotalTaxIncluded = Math.floor(subtotal * tax);
    $('#subTotal').val(formats.convertPrice(subtotalTaxIncluded));

    // 源泉徴収額(計算方法はSFに合わせる)
    let withholding = $('#salesTax').data('withholding');
    let withholdingTarget = (withholding == 1)? subtotal: subtotalTaxIncluded;
    let withholdingAmount = (withholding != 0)?
        ((withholdingTarget <= 1000000)?
            Math.floor(withholdingTarget * 0.1021):
            Math.floor(1000000           * 0.1021) + Math.floor((withholdingTarget - 1000000) * 0.2042)):
        0;
    $('#withholdingAmount').val(formats.convertPrice(withholdingAmount));

    // 実費
    let cost = parseInt(formats.convertNum($('#cost').val())) || 0;

    // 最終支払金額
    let payTotal = subtotalTaxIncluded - withholdingAmount + cost;
    $('#payTotal_show').val(formats.convertPrice(payTotal));
    $('#payTotal').val(payTotal);
}

// SF連携
function setupRelation()
{
    $('.sf-contract-exec').on('click', function(e) {
        const comment = $('#modal_sf_comment').val();
        $('#sf_comment').val(comment);
        formats.convertNumAllInputData();
        $('#form').submit();
    });
}
